import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from "react-bootstrap";
import { ModalAllder } from "./ModalAllder";
import { useGlobalDocModalContext } from "contexts/GlobalDocModalContext";
export default function GlobalModalNotiDoc() {
    var _modalNotiDocAlert_extra;
    var _useGlobalDocModalContext = useGlobalDocModalContext(), modalNotiDocAlert = _useGlobalDocModalContext.modalNotiDocAlert, setModalNotiDocAlert = _useGlobalDocModalContext.setModalNotiDocAlert;
    return /*#__PURE__*/ _jsxs(ModalAllder, {
        modal: modalNotiDocAlert,
        setModal: setModalNotiDocAlert,
        htitle: "แจ้งเตือน",
        hbtn: false,
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "flex justify-center",
                children: /*#__PURE__*/ _jsx("img", {
                    className: "w-[3.1vw] aspect-square mt-[17px]",
                    src: "/images/icon-alert-warn-red.png"
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "flex items-center flex-col mt-[17px]",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center font-[500]",
                        style: {
                            fontSize: "18px",
                            color: "#2F4858"
                        },
                        children: "เลขเอกสารมีการเปลี่ยนแปลงเป็น"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center font-[500] mt-[17px]",
                        style: {
                            fontSize: "20px",
                            color: "#FF6B00"
                        },
                        children: (_modalNotiDocAlert_extra = modalNotiDocAlert.extra) === null || _modalNotiDocAlert_extra === void 0 ? void 0 : _modalNotiDocAlert_extra.createdDocNumber
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        type: "button",
                        onClick: function() {
                            setModalNotiDocAlert(function(prev) {
                                return _object_spread_props(_object_spread({}, prev), {
                                    open: false
                                });
                            });
                        },
                        className: "btn-st-3 w-fit mt-[35px]",
                        children: "ปิด"
                    })
                ]
            })
        ]
    });
}
